import { Component, Input, OnInit, OnDestroy, ViewChildren, QueryList, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Location, CommonModule } from '@angular/common';
import { FormArray, FormGroup, FormControl, FormBuilder, AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatOptionModule } from '@angular/material/core';


import { Subject, BehaviorSubject, Subscription, forkJoin, take, Observable } from 'rxjs';
import { ProductTplService } from '@app/sales/product-tpl/productTpl.service';
import { CommonService } from '@app/common/common.service';
import { ValuesService } from '@app/common/values/values.service';
import { LoginService } from '@app/common/login.service';
import { AttachService } from '@app/shared/attach/attach.service';
import { SpinnerService } from '@app/shared/spinner.service';
import { AlertService } from '@app/shared/alert.service';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialog } from '@angular/material/dialog';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

import { ActionBarComponent } from '@app/shared/action-bar/action-bar.component';
import { InputPriceComponent } from '@app/shared/input-price/input-price.component';
import { MenuCommonComponent } from '@app/shared/menu-common/menu-common.component';
import { CufComponent } from '@app/shared/cuf/cuf.component';
import * as common from '@app/shared/_models/common';
import { C_value } from '@app/shared/_models/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ProductAttributeVal, ProductAttribute, TreeNodeDecl, Product, ProductPackagingVal, ProductTpl, SalesPriceHist, Ecopart } from '@app/shared/_models/product';
import { TreeNode } from '@app/shared/_models/common';

import { SmartSelectComponent } from '@app/shared/smart-select/smart-select.component'
import { SmartInputComponent } from '@app/shared/smart-input/smart-input.component'

import { MatDialogModule } from '@angular/material/dialog';

import { ImageCarouselComponent } from '../../shared/attach/image-carousel/image-carousel.component';
import { calc_margin, calc_margin_tx, calc_taux_marq, calc_taxi, calc_taxx, round_currency } from '@app/shared/util';

import { ProductTplGeneralComponent } from '@app/sales/product-tpl/product-tpl-general/product-tpl-general.component';

import {ObjectType, EventType, C_VALUES_UOM, C_VALUES_TYPE_DISCOUNT, C_VALUES_ECOPART, C_COMPONENT_PRODUCT} from "@app/shared/constants";



@Component({
  selector: 'app-product',
  imports: [InputPriceComponent, ProductTplGeneralComponent, SmartInputComponent, SmartSelectComponent, CommonModule, ImageCarouselComponent, MenuCommonComponent, MatButtonModule, MatIconModule, MatDialogModule, MatSelectModule, MatOptionModule, CufComponent, FormsModule, ReactiveFormsModule, ActionBarComponent, MatFormFieldModule, MatInputModule, MatTabsModule],
  templateUrl: './product.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product.component.scss'
})
export class ProductComponent implements OnDestroy {

  constructor(
     private fb: FormBuilder,
     private router: Router,
     private attachService:AttachService,
    private route: ActivatedRoute,
    private productTplService: ProductTplService,
    private commonService: CommonService,
    private valuesService: ValuesService,
    public loginService: LoginService,
    private alertService: AlertService,
  ) {}

  public product_id: number = 0;
  public isDragging = false;
  public product!: Product;
  public packaging: C_value[] = [];
  public typediscount : C_value[]=[];
  public productPackagingVals: ProductPackagingVal[] = [];
  private forkJoinSubscription!: Subscription;
  private productServiceSubscription!: Subscription;
  private navSubscription!: Subscription;
  public template_attachs_images : common.Attach[] = [];
  public attachs_images: common.Attach[] = [];
  public flat_product: boolean = false;
  public newPackagingId: number | null = null;
  public jumpId: number | null = null;   // id tapé dans l'en-tête pour changer de fiche ; null tant que ce n'est pas un entier > 0
  public ecopartTypes: C_value[] = [];   // c_values 14 : {id, seq, name, is_active, data: {code, org}}
  public cufsStructure: common.Cuf[] = [];
  private ecopartSub?: Subscription;
  @ViewChildren('qtybaseuomInput') qtybaseuomInputs!: QueryList<ElementRef<HTMLInputElement>>; 


    public dataSource: MatTableDataSource<AbstractControl> = new MatTableDataSource();
    public formGroup!: FormGroup;
  	public oldformGroup!: any;	// Snapshot (deep clone) of initial values for event diff

    public template_id: any;
    public eventtyp:number = EventType.INSERT;			// Insert event by default
    
    public tab: number=0;
    
    private childChange=false;	// Child tab change detection
    private routerevents$:any;
    loadProductEventsSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  
  




  ngOnInit(): void {
    this.product_id = Number(this.route.snapshot.paramMap.get('id'));			// Extract params. product id and template id are mandatory
    // this.template_id = Number(this.route.snapshot.paramMap.get('template'));


    if (this.product_id === 0) {	// New product
      console.log("New product  ");
			this.formGroup = this.fb.group({});
			this.oldformGroup = {};
    } else {
      this.loadProduct();
    }
    
		this.navSubscription = this.router.events.subscribe((event : any) => {
		  if (event instanceof NavigationEnd && this.template_id !==0) {	// Real reload, not a F5 on same page
		  	console.log("NavigationEnd, reloading");
		  	const id = Number(this.route.snapshot.paramMap.get('id'));
		  	if (id !== this.product_id) this.resetForProduct(id);	// le routeur réutilise le composant quand seul l'id change
		  	this.loadProduct();
		  }
		});
  }
  
  loadProduct() {
    this.eventtyp = EventType.UPDATE; 										// Update mode. Will issue an update event
    
    this.forkJoinSubscription = forkJoin({
      formGroupProduct:  this.productTplService.getProductAsFormGroup(this.product_id, ['attach']).pipe(take(1)),
      packaging: this.valuesService.getValues$(C_VALUES_UOM).pipe(take(1)),
      typediscount: this.valuesService.getValues$(C_VALUES_TYPE_DISCOUNT).pipe(take(1)),
      ecopartTypes: this.valuesService.getValues$(C_VALUES_ECOPART).pipe(take(1)),
      cufsStructure: this.commonService.getCufs(C_COMPONENT_PRODUCT).pipe(take(1)),
    }).subscribe(({ formGroupProduct, packaging , typediscount, ecopartTypes, cufsStructure}) => {
      console.log('formGroupProduct',formGroupProduct);
      console.log('productPackagingVals=',  formGroupProduct);
      console.log('packaging=', JSON.stringify(packaging), packaging);
      this.formGroup = formGroupProduct;
      this.ecopartTypes = Array.isArray(ecopartTypes) ? ecopartTypes : (ecopartTypes?.data ?? []);
      // Avant la photo : old et new portent la même forme {id, seq, code, org, name, value}, complétée depuis c_values 14 par id.
      this.formGroup.setControl('lnk_ecoparts', new FormArray(Ecopart.withTypes(this.lnkEcopartsFormArray?.getRawValue(), this.ecopartTypes).map(Ecopart.asFormGroup)));
      this.oldformGroup = JSON.parse(JSON.stringify(formGroupProduct.getRawValue()));
      this.packaging = packaging;
      this.typediscount = typediscount;
      this.cufsStructure = cufsStructure;
      const cufsGroup = this.formGroup.get('data')?.get('cufs') as FormGroup;
      if (cufsGroup) {
        cufsStructure.forEach((cuf: common.Cuf) => {
          if (cuf.id !== undefined && !cufsGroup.contains(String(cuf.id))) {
            cufsGroup.addControl(String(cuf.id), new FormControl(''));
          }
        });
      }
      // this.initEcopartFormArray();

      if (!this.formGroup.value.lnk_template.has_variants){ 
        this.flat_product = true;
        this.formGroup.get('name')!.disable()   // je pense inutile
      }
      
      // regle métier uniquement dans le GUI donc modifiable en base si pas ok
      // on a forcément 1 packaging qui correspond a 1 uvc après il peut être commercialisabe ou non au choix  et il se trouve en premier
      // sinon l'uvc de base est 1  l unite
      // on a qu un is default 
      const baseuomId = this.formGroup?.get('lnk_template')?.get('baseuom')?.value ?? 1;
      const lnkPackagings = this.formGroup.get('lnk_packagings') as FormArray;

      if (lnkPackagings) {
        let needsSave = false;

        // Chercher le packaging qui correspond à baseuom
        const baseuomIndex = lnkPackagings.controls.findIndex(
          (ctrl: AbstractControl) => ctrl.get('packaging')?.value === baseuomId
        );

        if (baseuomIndex !== -1) {   // Le packaging baseuom existe
         
          const baseuomControl = lnkPackagings.at(baseuomIndex);
          baseuomControl.get('qtybaseuom')?.disable();

          // Le mettre en premier s'il n'y est pas déjà
          if (baseuomIndex !== 0) {
            lnkPackagings.removeAt(baseuomIndex);
            lnkPackagings.insert(0, baseuomControl);
          }

          console.log('baseuomControl',baseuomControl);
          // S'assurer que qtybaseuom est à 1
          if ( + (baseuomControl.get('qtybaseuom')?.value) !== 1) {
            baseuomControl.get('qtybaseuom')?.setValue(1);
            needsSave = true;
          }

          if(!needsSave){ // si on ne fait pas d'auto submit on appelle la fonction qui calcul 
            this.on_qtyunitpriceuom_change(0)
           }

        } else {
          // Le packaging baseuom n'existe pas, le créer
          const newPackagingVal = new ProductPackagingVal();
          newPackagingVal.id = 0;
          newPackagingVal.product = this.product_id;
          newPackagingVal.packaging = baseuomId;
          newPackagingVal.is_purchasable = true;
          newPackagingVal.is_sellable = true;
          newPackagingVal.is_default = true;
          newPackagingVal.barcode = '';
          newPackagingVal.qtybaseuom = 1;
          // newPackagingVal.qtyunitpriceuom = 1; 

          // L'insérer en première position
          const newPackagingFg = ProductPackagingVal.asFormGroup(newPackagingVal);
          newPackagingFg.get('qtyunitpriceuom')?.disable();
          lnkPackagings.insert(0, newPackagingFg);
          needsSave = true;
        }
        // Vérifier qu'il y a un seul is_default à true
        let foundDefault = false;
        lnkPackagings.controls.forEach((ctrl: AbstractControl) => {
          if (ctrl.get('is_default')?.value === true) {
            if (foundDefault) {
              // On a déjà trouvé un default, on passe celui-ci à false
              ctrl.get('is_default')?.setValue(false);
              needsSave = true;
            } else {
              foundDefault = true;
            }
          }
        });

        // Si aucun is_default trouvé, on met le premier à true
        if (!foundDefault && lnkPackagings.length > 0) {
          lnkPackagings.at(0).get('is_default')?.setValue(true);
          needsSave = true;
        }

        // Auto save hyper dangereux fait un submit si on a effectuer des changement dans les forms packagings afin de save les changements
        // Sauvegarder si nécessaire  
        if (needsSave) {   setTimeout(() => this.onSubmit('auto-save')); }

        // Ajouter le nom à chaque packaging
        lnkPackagings.controls.forEach((packagingGroup: AbstractControl) => {
          const fg = packagingGroup as FormGroup;
          const packagingId = fg.get('packaging')?.value;
          const matchedPackaging = this.packaging.find((p: C_value) => p.id === packagingId);
          if (matchedPackaging) {
            fg.addControl('name', new FormControl(matchedPackaging.name));
          }
        });
      }
      console.log('this.formGroup.get(lnk_packagings)',this.formGroup.get('lnk_packagings'));

      // this.oldFormGroup = JSON.parse(JSON.stringify(this.formGroup.value));		// Take a snapshot of newly loded product
      // console.log('this.formGroup',this.formGroup);
      // console.log('JSON.stringify(this.formGroup.value )',JSON.stringify(this.formGroup.value ));





      // // Attachs du template (mémo + images)
      // const tplAttachs: any[] = this.formGroup.value.lnk_template?.lnk_attachs ?? [];
      // console.log('tplAttachs',tplAttachs);
      // const templateId = this.formGroup.value.lnk_template?.id;
      // if (tplAttachs.length) {
      //   this.attachService.ensureDefaultMemo(
      //     this.formGroup.get('lnk_template')!.get('lnk_attachs') as FormArray,
      //     // tplAttachs,
      //     constants.OBJECTTYP_TEMPLATE,
      //     templateId
      //   );
      //   this.template_attachs_images = this.attachService.generate_attachs_object_with_thumbnail(tplAttachs);
      // } else if (templateId) {
      //   // L'API /product ne retourne pas lnk_template.lnk_attachs → appel séparé
      //   this.productTplService.getTemplate(templateId, []).pipe(take(1)).subscribe((tplData: any[]) => {
      //     const attachs: any[] = tplData?.[0]?.lnk_attachs ?? [];
      //     if (attachs.length) {
      //       this.attachService.ensureDefaultMemo(
      //         this.formGroup.get('lnk_template')!.get('lnk_attachs') as FormArray,
      //         // attachs,
      //         constants.OBJECTTYP_TEMPLATE,
      //         templateId
      //       );
      //       this.template_attachs_images = this.attachService.generate_attachs_object_with_thumbnail(attachs);
      //     }
      //   });
      // }




      console.log('Salut from : 9999999999999');
      console.log('this.formGroup?.value?.lnk_attachs',this.formGroup?.value?.lnk_attachs);

      // Attachs du produit — préserver les miniatures existantes pour éviter le scintillement au reload
      const serverProductAttachs = this.formGroup?.value?.lnk_attachs;
      if (serverProductAttachs) {
        const cachedUrls = new Map(this.attachs_images.filter(a => a.id && a.thumbnailLocalUrl).map(a => [a.id!, a.thumbnailLocalUrl!]));
        serverProductAttachs.forEach((a: any) => { if (cachedUrls.has(a.id)) a.thumbnailLocalUrl = cachedUrls.get(a.id); });
        this.attachs_images = this.attachService.generate_attachs_object_with_thumbnail(serverProductAttachs);
      }
      // Attachs du Template — même traitement anti-scintillement
      const serverTplAttachs = this.formGroup.value.lnk_template?.lnk_attachs;
      if (serverTplAttachs) {
        const cachedUrls = new Map(this.template_attachs_images.filter(a => a.id && a.thumbnailLocalUrl).map(a => [a.id!, a.thumbnailLocalUrl!]));
        serverTplAttachs.forEach((a: any) => { if (cachedUrls.has(a.id)) a.thumbnailLocalUrl = cachedUrls.get(a.id); });
        this.template_attachs_images = this.attachService.generate_attachs_object_with_thumbnail(serverTplAttachs);
      }


      const hasMemo = (this.formGroup.get('lnk_attachs') as FormArray).value.some((a: any) => a.data?.['flags']?.includes('is_default_memo'));
      if (!hasMemo) {
        const newMemo = this.attachService.getDefaultMemo(ObjectType.PRODUCT, this.product_id);
        (this.formGroup.get('lnk_attachs') as FormArray).push(newMemo);
      }

















    });

  }



    /** Gestion unifiée upload fichier ou vidéo YouTube — même pattern placeholder/completed */
    private handleMediaUpload(upload$: Observable<any>): void {
      upload$.subscribe({
        next: (response: any) => {
          if (response?.status === 'placeholder' && response?.item) {
            this.attachs_images.push(response.item);
          } else if (response?.status === 'completed' && response?.item) {
            const idx = this.attachs_images.findIndex(a => a.seq === response.item.seq);
            if (idx !== -1) {
              this.attachs_images[idx] = response.item;
  
              const sub = this.attachService.loadThumbnailImage$(response.item).subscribe(blob => {
                this.attachs_images[idx].thumbnailLocalUrl = URL.createObjectURL(blob);
                sub.unsubscribe();
              });
            }
          }
        },
        error: (error: any) => console.error('Request failed', error)
      });
    }
  
    onDragOver(event: DragEvent): void {
      event.preventDefault();
      this.isDragging = true;
    }

    onDragLeave(event: DragEvent): void {
      if ((event.currentTarget as HTMLElement).contains(event.relatedTarget as HTMLElement)) return;
      this.isDragging = false;
    }

    onDrop(event: DragEvent): void {
      event.preventDefault();
      this.isDragging = false;
      const file = event.dataTransfer?.files[0];
      if (!file) return;
      this.handleMediaUpload(
        this.attachService.uploadMediaWithPlaceholder$(file, ObjectType.PRODUCT, this.product_id, this.attachs_images)
      );
    }

    onFileSelected(event: any): void {
      const file: File = event.target.files[0];
      console.log('Salut from : on file selected');
      if (!file) return;
      this.handleMediaUpload(
        this.attachService.uploadMediaWithPlaceholder$(file, ObjectType.PRODUCT, this.product_id, this.attachs_images)
      );
    }
  
    uploadYoutubeVideo(youtubeUrl: string): void {
      if (!youtubeUrl?.trim()) return;
      this.handleMediaUpload(
        this.attachService.uploadYoutubeWithPlaceholder$(youtubeUrl, ObjectType.PRODUCT, this.product_id, this.attachs_images)
      );
    }
  

// onFileSelected(event: any): void {
//   const file: File = event.target.files[0];
//   if (!file) return;
//   this.attachService.uploadMediaWithPlaceholder$(file, constants.OBJECTTYP_PRODUCT, this.product_id, this.attachs_images)
//     .subscribe({
//       next: () => this.loadProduct(),
//       error: (error) => console.error('Request failed', error)
//     });
// }

// uploadYoutubeVideo(youtubeUrl: string): void {
//   if (!youtubeUrl?.trim()) return;
//   this.attachService.uploadYoutubeWithPlaceholder$(youtubeUrl, constants.OBJECTTYP_PRODUCT, this.product_id, this.attachs_images)
//     .subscribe({
//       next: () => this.loadProduct(),
//       error: (error) => console.error('Request failed', error)
//     });
// }

onSubmit($event : any){
    // Le serveur refuse l'event entier sur une value null (Decimal obligatoire) : 0 est accepté, un montant vidé ne part pas.
    const sansMontant = this.lnkEcopartsFormArray?.controls.find(c => c.get('value')?.invalid);
    if (sansMontant) {
      this.alertService.error(`Éco-participation « ${sansMontant.get('name')?.value || 'filière ' + sansMontant.get('id')?.value} » sans montant : saisir un montant (0 accepté) ou supprimer la ligne`);
      return;
    }
    this.productServiceSubscription = this.productTplService.postProductEvent(this.eventtyp, this.product_id, ObjectType.PRODUCT, this.oldformGroup, this.formGroup).subscribe({
      next: (response: any) => {
        console.log("Server response: " + JSON.stringify(response));
        if (response?.data?.barcode_conflicts?.length) {
          const details = response.data.barcode_conflicts.map((c: any) => c.message).join('\n');
          this.alertService.error(`${response.error_msg}\n${details}`);
        } else if (response?.success === false) {         // Refus métier en HTTP 200 : ne pas afficher « enregistré »
          this.alertService.error(response.error_msg || response.msg || 'Enregistrement refusé par le serveur');
        } else {
          this.alertService.success('Produit enregistré');
        }
        // Dans tous les cas on relit l'état réel du serveur : la fiche ne doit jamais afficher des modifications qui n'ont pas été prises
        this.reload( response?.data?.product_id );
      },
      error: (err: any) => {
        // POST /event rend un 500 avec le message en texte brut (event/src/routes.rs) : sans ce bloc l'échec était muet
        const msg = typeof err?.error === 'string' ? err.error : (err?.error?.error_msg || err?.error?.msg || err?.message || 'Erreur inconnue');
        console.error("Product save failed:", err);
        this.alertService.error(`Enregistrement du produit échoué : ${msg}`);
        this.reload();
      }
    });
}

reload( id : number = 0  ){
  if( !id || id ==0 ) { id  =  this.product_id }
  // this.onSubmit(null);
  this.router.navigate(['/sales/product/' + id ]);	// Reload Template
}

// Rien de l'ancien produit ne doit survivre, pas même les enfants : leurs verrous sont posés à leur ngOnInit.
private resetForProduct(id: number): void {
  this.forkJoinSubscription?.unsubscribe();	// un chargement en vol de l'ancien id écraserait la nouvelle fiche
  this.product_id = id;
  this.formGroup = undefined as unknown as FormGroup;	// @if (formGroup) détruit puis recrée toute la fiche
  this.oldformGroup = {};
  this.flat_product = false;
  this.attachs_images = [];
  this.template_attachs_images = [];
  this.jumpId = null;
}

onJumpIdChange(value: string): void {
  const id = Number((value ?? '').toString().trim());
  this.jumpId = Number.isInteger(id) && id > 0 ? id : null;
}

// GET /product/{id} répond 500 sur un id inconnu : on vérifie avant de quitter la fiche, qui reste affichée en cas d'échec.
goToProduct(): void {
  const id = this.jumpId;
  if (!id || id === this.product_id) return;
  this.productTplService.getProduct(id).pipe(take(1)).subscribe({
    next: () => this.router.navigate(['/sales/product', id]),
    error: () => this.alertService.error(`Produit #${id} introuvable`),
  });
}

get packagingsFormArray(): FormArray | null { return this.formGroup?.get('lnk_packagings') as FormArray; }

get cufGroup(): FormGroup { return this.formGroup?.get('data')?.get('cufs') as FormGroup; }

get purchasePriceHistsFormArray(): FormArray | null { return this.formGroup?.get('lnk_purchase_price_hists') as FormArray; }

getUnitPriceFromValue(price: any): number | null {
  const p = +price;
  if (!p) return null;
  const defaultPackaging = this.packagingsFormArray?.controls.find(ctrl => ctrl.get('is_default')?.value === true);
  const qty = defaultPackaging?.get('qtyunitpriceuom')?.value;
  return qty ? p / qty : null;
}

getMarginRow(pph: AbstractControl): { marge: number | null, marge_pct: number | null, marque_pct: number | null } {
  const achat = +pph.get('price')?.value;
  const vente = +this.formGroup?.get('price_taxx')?.value;
  if (!achat || !vente) return { marge: null, marge_pct: null, marque_pct: null };
  return {
    marge:      round_currency(calc_margin(achat, vente)),
    marge_pct:  round_currency(calc_margin_tx(achat, vente) * 100),
    marque_pct: round_currency(calc_taux_marq(achat, vente) * 100),
  };
}

get salesPriceHists(): SalesPriceHist[] { return this.formGroup?.get('lnk_sales_price_hists')?.value ?? []; }

// Historique : l'instantané sales_price_hist.ecoparts tel qu'écrit à ce prix (code, à défaut nom ou id).
formatEcopart(ecoparts: any[] | undefined): string {
  const items = (ecoparts ?? []).map(Ecopart.from).sort((a, b) => a.seq - b.seq);
  if (!items.length) return '—';
  const fmt = new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 4 });
  return items.map(e => `${e.code || e.name || 'filière ' + e.id} ${fmt.format(e.value)}`).join(' · ');
}

get salespartnerpricelsFormArray(): FormArray | null {  return this.formGroup?.get('lnk_salespartnerpricels') as FormArray; }

getPackagingName(packagingId: number): string {
  const pkg = this.packaging.find(p => p.id === packagingId);
  return pkg?.name || '';
}
get_tpl_unitpriceuom(): string {
 return this.getPackagingName(this.formGroup?.get('lnk_template')?.get('unitpriceuom')?.value ?? '')
} 
getDiscName (strategy: number): string {
  const dis = this.typediscount.find(p => p.id === strategy);
  return dis?.name || '';
}

getUnitPrice(priceFieldName: string): number | null {
  const price = this.formGroup?.get(priceFieldName)?.value;
  
  const defaultPackaging = this.packagingsFormArray?.controls.find(    ctrlPack => ctrlPack.get('is_default')?.value === true );  //  un peux inutile d'alléer chercher le default car cela fonctionnerait avec tous
  const qtyunitpriceuom = defaultPackaging?.get('qtyunitpriceuom')?.value;
  if (price && qtyunitpriceuom) {
    return price / qtyunitpriceuom;
  }
  return null;
}

addPackaging(packaging_id: any): void {
  console.log('event', packaging_id);
  console.log('this.packagingsFormArray.value', this.packagingsFormArray?.value);
  if (!packaging_id  || !this.packagingsFormArray) return;

  const newPackagingVal = new ProductPackagingVal();
  newPackagingVal.id = 0;
  newPackagingVal.product = this.product_id;
  newPackagingVal.packaging = packaging_id;
  newPackagingVal.is_default = false;
  newPackagingVal.is_purchasable = true;
  newPackagingVal.is_sellable = true;
  newPackagingVal.barcode = '';
  newPackagingVal.qtybaseuom = undefined;
  newPackagingVal.qtyunitpriceuom = undefined;

  this.packagingsFormArray.push(ProductPackagingVal.asFormGroup(newPackagingVal));

  // Focus sur l'input qtybaseuom du nouvel élément après le rendu
  setTimeout(() => {
    const inputs = this.qtybaseuomInputs?.toArray();
    if (inputs && inputs.length > 0) {
      inputs[inputs.length - 1].nativeElement.focus();
    }
  });
}

on_qtyunitpriceuom_change(modifiedIndex: number): void {
  if (!this.packagingsFormArray) return;

  const modifiedControl = this.packagingsFormArray.at(modifiedIndex);
  const qtybaseuom = modifiedControl.get('qtybaseuom')?.value;
  const qtyunitpriceuom = modifiedControl.get('qtyunitpriceuom')?.value;

  if (!qtybaseuom || qtybaseuom === 0 || !qtyunitpriceuom) return;

  // Calcul du ratio unitaire
  const ratio = qtyunitpriceuom / qtybaseuom;

  // Mise à jour de tous les autres packagings
  this.packagingsFormArray.controls.forEach((control, index) => {
    if (index !== modifiedIndex) {
      const otherQtybaseuom = control.get('qtybaseuom')?.value;
      if (otherQtybaseuom) {
        const newQtyunitpriceuom = ratio * otherQtybaseuom;
        control.get('qtyunitpriceuom')?.setValue(newQtyunitpriceuom);
      }
    }
  });
}

on_qtybaseuom_change(modifiedIndex: number): void {
  if (!this.packagingsFormArray) return;

  const modifiedControl = this.packagingsFormArray.at(modifiedIndex);
  const isDefault = modifiedControl.get('is_default')?.value;
  const newQtybaseuom = modifiedControl.get('qtybaseuom')?.value;

  if (!newQtybaseuom) return;

  if (isDefault) { // Cas 1 : Packaging par défaut - recalculer le ratio et mettre à jour tous les packagings
    const qtyunitpriceuom = modifiedControl.get('qtyunitpriceuom')?.value;
    if (!qtyunitpriceuom) return;

    const ratio = qtyunitpriceuom / newQtybaseuom;

    // Mettre à jour tous les autres packagings avec le nouveau ratio
    this.packagingsFormArray.controls.forEach((control, index) => {
      if (index !== modifiedIndex) {
        const otherQtybaseuom = control.get('qtybaseuom')?.value;
        if (otherQtybaseuom) {
          const newQtyunitpriceuom = ratio * otherQtybaseuom;
          control.get('qtyunitpriceuom')?.setValue(newQtyunitpriceuom);
        }
      }
    });
  } else { // Cas 2 : Packaging non défaut - calculer son qtyunitpriceuom à partir du ratio du packaging par défaut
    const defaultControl = this.packagingsFormArray.controls.find(c => c.get('is_default')?.value);
    if (!defaultControl) return;

    const defaultQtybaseuom = defaultControl.get('qtybaseuom')?.value;
    const defaultQtyunitpriceuom = defaultControl.get('qtyunitpriceuom')?.value;

    if (!defaultQtybaseuom || !defaultQtyunitpriceuom) return;

    const ratio = defaultQtyunitpriceuom / defaultQtybaseuom;
    const newQtyunitpriceuom = ratio * newQtybaseuom;
    modifiedControl.get('qtyunitpriceuom')?.setValue(newQtyunitpriceuom);
  }
}

// Prix calculé gardé à 4 décimales : le serveur stocke le HT reçu et en dérive le TTC ; input-price n'en affiche que 2.
on_price_taxx_change(): void {
  console.log('Salut from : on_price_taxx_change');
  const taxx = +this.formGroup.get('price_taxx')?.value;
  const vat_rate = +this.formGroup.get('lnk_template')?.get('vat_rate')?.value || 0;
  if (!isNaN(taxx)) {
    this.formGroup.get('price_taxi')?.setValue(round_currency(calc_taxi(taxx, vat_rate), 4), { emitEvent: false });
  }
}

on_price_taxi_change(): void {
  console.log('Salut from : on_price_taxi_change');
  const taxi = +this.formGroup.get('price_taxi')?.value;
  const vat_rate = +this.formGroup.get('lnk_template')?.get('vat_rate')?.value || 0;
  if (!isNaN(taxi)) {
    this.formGroup.get('price_taxx')?.setValue(round_currency(calc_taxx(taxi, vat_rate), 4), { emitEvent: false });
  }
}

// Seul LE conditionnement de base (le premier de l'unité de base, mis en tête par ngOnInit) est protégé : un second « Unité » se retire.
isBasePackaging(index: number): boolean {
  const baseuomId = this.formGroup?.get('lnk_template')?.get('baseuom')?.value ?? 1;
  return (this.packagingsFormArray?.controls.findIndex(c => c.get('packaging')?.value === baseuomId) ?? -1) === index;
}

removePackaging(index: number, packagingVal_id:number): void {
  if (!this.packagingsFormArray) return;
  // Ligne jamais enregistrée (addPackaging pose id = 0) : rien à retirer côté serveur, retrait par index — sciemment,
  // plusieurs lignes neuves partagent l'id 0.
  if (!packagingVal_id) { this.packagingsFormArray.removeAt(index); return; }
  // Le serveur DÉSACTIVE le conditionnement (sales_order_l.ppv le désigne) et peut refuser en 200 + success:false ;
  // on retire la ligne de l'écran après sa réponse, par identité : `index` est périmé si l'on a cliqué entre-temps.
  this.productServiceSubscription = this.productTplService.postRemovePackagingToProduct(packagingVal_id, this.product_id).subscribe({
    next: (response: any) => {
      if (response?.success === false) {
        this.alertService.error(response.error_msg || response.msg || 'Retrait du conditionnement refusé par le serveur');
        return;
      }
      const i = this.packagingsFormArray?.controls.findIndex(c => c.get('id')?.value === packagingVal_id) ?? -1;
      if (i >= 0) { this.packagingsFormArray?.removeAt(i); }
    },
    error: (err: any) => this.alertService.error(`Retrait du conditionnement impossible : ${err?.error?.error_msg ?? err?.error ?? err?.message ?? err}`),
  });
}



setDefaultPackaging(index: number): void {
  if (!this.packagingsFormArray) return;
  this.packagingsFormArray.controls.forEach((control, i) => {
    control.get('is_default')?.setValue(i === index);
    // Enable qtyunitpriceuom uniquement pour le packaging par défaut
    if (i === index) {
      control.get('qtyunitpriceuom')?.enable();
    } else {
      control.get('qtyunitpriceuom')?.disable();
    }
  });
}





  /** Même pattern que ProductTplGeneralComponent.defaultImage */
  get defaultProductImage(): common.Attach | undefined {
    return this.attachs_images.find(a => a.data?.['flags']?.includes('is_default_image')) 
  }

  get lnkEcopartsFormArray(): FormArray { return this.formGroup?.get('lnk_ecoparts') as FormArray; }

  // LOV : filières actives de c_values 14 que l'article ne porte pas encore (clé = id).
  get ecopartActiveTypes(): C_value[] {
    const usedIds: number[] = (this.lnkEcopartsFormArray?.value ?? []).map((e: any) => e.id);
    return this.ecopartTypes.filter(t => t.is_active && !usedIds.includes(t.id!));
  }

  // Organisme et code de la filière, affichés sous son nom.
  ecopartDetail(ep: AbstractControl): string {
    return [ep.get('org')?.value, ep.get('code')?.value].filter(Boolean).join(' · ');
  }

  addEcopart(typeId: number): void {
    if (!typeId) return;
    const type = this.ecopartTypes.find(t => t.id === typeId);
    if (!type || !this.lnkEcopartsFormArray) return;
    const at = this.lnkEcopartsFormArray.controls.findIndex(c => (c.get('seq')?.value ?? 0) > (type.seq ?? 0)); // rangée à sa place (seq)
    this.lnkEcopartsFormArray.insert(at < 0 ? this.lnkEcopartsFormArray.length : at, Ecopart.asFormGroup(Ecopart.fromType(type)));
  }

  removeEcopart(index: number): void {
    this.lnkEcopartsFormArray?.removeAt(index);
  }


  get defaultMemoControl(): FormControl | null {
    const lnkAttachs = this.formGroup.get('lnk_attachs') as FormArray;
    const index = lnkAttachs.controls.findIndex((ctrl) => {
      const data = ctrl.get('data')?.value;
      return data?.flags?.includes('is_default_memo');
    });
    if (index === -1) return null;
    return lnkAttachs.at(index).get('memo') as FormControl;
  }

  ngOnDestroy(): void {
    if (this.forkJoinSubscription) { this.forkJoinSubscription.unsubscribe(); }
		if (this.productServiceSubscription) this.productServiceSubscription.unsubscribe();
		if (this.navSubscription) this.navSubscription.unsubscribe();
    this.ecopartSub?.unsubscribe();


  }

}
